import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function Paper({
  position = [0.16, -0.07, 41.79],
  rotation = [0, 0, 0],
  scale = 1,
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/paper.glb");
  const paperScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    paperScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [paperScene]);

  return (
    <RigidBody
      type="fixed"
      colliders={false}
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={paperScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/paper.glb");
